import React, { useState } from 'react';
import { CourseCardsContainer, CategoryCard, CategoryImage, CategoryTitle, CategoryNumber } from './CategoryCardsStyle';
import { getCategoryCardDetails } from '../../helpers/categoryCardHelper';
import { APP_CONSTANTS, defaultColor } from '../../constants';
import BrowseByCategory from '../BrowserByCategory';
import { getColorStyle } from 'src/consumer/helpers/tileCardHelper';
import { useRef } from 'react';
import { useEffect } from 'react';
import { HorizontalScrollLeftButton, HorizontalScrollRightButton } from '../CardList/CardListStyle';

export const renderCardsList = (props) => {
    const { cardsData, setSelectedCategory, cardsType, cardsLayout } = props;

    return cardsData.map((card, index) => {
        const { categoryTitle, categoryCount, categoryImage, bgColor, categoryId } = getCategoryCardDetails(card, cardsType);

        return (
            <CategoryCard bgColor={getColorStyle(defaultColor, '', bgColor, "solid")} key={index} onClick={() => setSelectedCategory({ selectedCardTitle: categoryTitle, selectedCardId: categoryId })}>
                <CategoryTitle>
                    {categoryTitle}
                </CategoryTitle>
                <CategoryNumber>
                    {cardsLayout === "vertical_list_with_count" && (!categoryCount ? "No Items Yet" : `${categoryCount} ${categoryCount === 1 ? 'item' : 'items'}`)}
                </CategoryNumber>
                {categoryImage && <CategoryImage imgURL={APP_CONSTANTS.MEDIA_URL + (categoryImage)} />}
            </CategoryCard>
        )
    })
}

const CategoryCards = (props) => {
    const [selectedCategory, setSelectedCategory] = useState(false);
    const { cardsType, tileId, cardsData, policyId, cardsCategory, tilePolicyId } = props;

    const { areTileItemsHovered } = props;
    const cardRef = useRef();
    const [leftButtonVisible, setLeftButtonVisible] = useState(false);
    const [rightButtonVisible, setRightButtonVisible] = useState(false);
    const handleScrollLeft = () => {
        if (cardRef.current) {
            const containerWidth = cardRef.current.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft -= scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScrollRight = () => {
        if (cardRef.current) {
            const containerWidth = cardRef.current.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft += scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScroll = (event) => {
        const container = event.target;
        const scrollPosition = container.scrollLeft;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }
    useEffect(() => {
        const container = cardRef.current;
        const scrollPosition = container.scrollLeft;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }, []);

    return (
        <CourseCardsContainer ref={cardRef} onScroll={handleScroll}>
            {selectedCategory &&
                <BrowseByCategory
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    categoryList={cardsData}
                    cardsType={cardsType}
                    tileId={tileId}
                    policyId={policyId}
                    cardsCategory={cardsCategory}
                    tilePolicyId={tilePolicyId}
                />
            }

            {areTileItemsHovered && leftButtonVisible &&
                <HorizontalScrollLeftButton onClickFunction={handleScrollLeft} />
            }

            {renderCardsList({ ...props, setSelectedCategory })}

            {areTileItemsHovered && rightButtonVisible &&
                <HorizontalScrollRightButton onClickFunction={handleScrollRight} />
            }

        </CourseCardsContainer>
    )
}

export default CategoryCards;
